import { Language } from '@eneco/common/application';
import { CustomerLanguageDto } from '@eneco/dc-be/client';

export const LANGUAGES_MAP: { [key in CustomerLanguageDto]: { [key in Language]: string } } = {
  Dutch: {
    nl: 'Nederlands',
    fr: 'Néerlandais',
    en: 'Dutch',
  },
  French: {
    nl: 'Frans',
    fr: 'Français',
    en: 'French',
  },
  English: {
    nl: 'Engels',
    fr: 'Anglais',
    en: 'English',
  },
} as const;

/**
 * Converts a Language to CustomerLanguageDto
 * @param language - The language code ('nl' or 'fr')
 * @returns CustomerLanguageDto - 'Dutch' for 'nl', 'French' for 'fr', defaults to 'Dutch'
 */
export const languageToCustomerLanguageDto = (language: Language): CustomerLanguageDto => {
  if (language === 'nl') return 'Dutch';
  if (language === 'fr') return 'French';
  return 'Dutch';
};

export const languageToContactFormLanguageDto = (language: Language): 'DUTCH' | 'FRENCH' => {
  return language === 'nl' ? 'DUTCH' : 'FRENCH';
};
